import { LifeCycleTypes } from '@formily/core';
import { addEffectError, removeEffectError } from '../../utils';
import { genGetMultiFieldsRes } from './onMultiFieldsValueChange';
export const genValidateField = ($, form) => {
  const validateField = (key, triggers, cb) => {
    const effectArray = [];
    let pushedEffect = false;
    const lastRuleTextMap = {};

    const wrappedCb = key => {
      const fieldState = form.getFieldState(key);
      const formValues = form.getFormState(s => s.values);

      if (!fieldState) {
        return;
      }

      if (!pushedEffect) {
        effectArray.push({
          unsubscribe: () => form.clearErrors(fieldState.name)
        });
        pushedEffect = true;
      }

      const value = fieldState.value;
      const getMultiFieldsRes = genGetMultiFieldsRes(form);
      const res = cb({ ...getMultiFieldsRes(triggers),
        value,
        triggerFieldState: fieldState,
        formValues
      });

      function setError(validateRes) {
        form.setFieldState(fieldState.name, fieldState => {
          if (fieldState.unmounted) {
            form.clearErrors(fieldState.name);
            return null;
          }

          const lastRuleText = lastRuleTextMap[fieldState.name];

          if (lastRuleText) {
            removeEffectError(fieldState, lastRuleText);
          }

          lastRuleTextMap[fieldState.name] = validateRes;

          if (validateRes == null) {
            return;
          }

          addEffectError(fieldState, validateRes);
        });
      }

      if (res instanceof Promise) {
        res.then(r => {
          setError(r);
        });
        return;
      }

      setError(res);
    }; // 这里记录下被校验的值


    const fieldMap = {};
    $(LifeCycleTypes.ON_FIELD_UNMOUNT, key).subscribe(s => {
      delete fieldMap[s.name];
    });
    $(LifeCycleTypes.ON_FIELD_MOUNT, key).subscribe(s => {
      fieldMap[s.name] = true;
    });
    effectArray.push($(LifeCycleTypes.ON_FIELD_VALIDATE_START, key).subscribe(s => {
      wrappedCb(s.name);
    }));
    [key, ...triggers].forEach(key => {
      effectArray.push($(LifeCycleTypes.ON_FIELD_VALUE_CHANGE, key).subscribe(() => {
        Object.keys(fieldMap).forEach(key => {
          wrappedCb(key);
        });
      }));
    });
    return {
      clearEffect: () => {
        effectArray.forEach(v => {
          v.unsubscribe();
        });
      }
    };
  };

  return validateField;
};
//# sourceMappingURL=es/Form/extendsEffects/validateField.js.map